<BI-grid-layout [cols]="['auto']" [gap]="3">
    <BI-grid-layout-item class="main">
        <bi-control-list-2col [formGroup]="formGroup" [controlList]="generalControls"></bi-control-list-2col>
    </BI-grid-layout-item>
</BI-grid-layout>